import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@store';

interface RolesGuardProps {
  roles: string[];
  children: ReactNode;
}

export const RolesGuard = ({ roles, children }: RolesGuardProps) => {
  const userRoles = useSelector((state: RootState) => state.domainUserAuth.roles);

  const hasPermission = roles.some(role => userRoles?.includes(role));

  if (!hasPermission) return null;

  return <>{children}</>;
};
